<template>
  <div>
    <div class="flux-theme layout">
      <Header></Header>
      <router-view></router-view>
      <Footer></Footer>
      <popups></popups>
    </div>
  </div>
</template>

<script>
import Header from '@/components/main/header/Header'
import Footer from '@/components/main/footer/Footer'
import Popups from '@/components/main/popup/Popups'

export default {
  name: 'new',
  mixins: [],
  components: {
    Header,
    Footer,
    Popups,
  },
  computed: {
    configurationIdAndLocale() {
      if (this.$store.getters.configurationId && this.$store.getters.locale) {
        return this.$store.getters.configurationId + this.$store.getters.locale
      } else return false
    },
    theme() {
      return this.$store.getters.theme
    },
    loadingError() {
      return this.$store.state.iquote.iquoteLoadingError
    },
  },
  mounted() {
    if (!this.$route.params.iquoteId) this.$store.dispatch('getContentDefault')
  },
  watch: {
    loadingError() {
      this.$store.dispatch('getContentDefault')
    },
    configurationIdAndLocale(val) {
      if (val) this.$store.dispatch('getContent')
    },
    theme(value) {
      if (value === 'engieTheme') {
        import(/* webpackChunkName: "theme-engie-css" */ '@/scss/engie/engie.scss')
      }
    },
  },
}
</script>
